export type ProductArrayFilterKey =
    | 'subType'
    | 'labels'
    | 'type'
    | 'shared'
    | 'duration'
    | 'destination'
    | 'departureCity'
    | 'arrivalCity'
    | 'pax'
    | 'vehicleType'
    | 'transmission'
    | 'passengers'
    | 'customerType'
    | 'breakfastType'
    | 'region'
    | 'language';

export type ProductFiltersState = Record<ProductArrayFilterKey, string[]> & {
    /** Hôtels « Piscine » : ne garder que les hôtels avec piscine. */
    swimmingPool: boolean;
    /** Activités « Pick-up » : ne garder que celles avec pick-up. */
    pickUp: boolean;
    priceMin: number | null;
    priceMax: number | null;
};

export const emptyFilters: ProductFiltersState = {
    subType: [],
    labels: [],
    type: [],
    shared: [],
    duration: [],
    destination: [],
    departureCity: [],
    arrivalCity: [],
    pax: [],
    vehicleType: [],
    transmission: [],
    passengers: [],
    customerType: [],
    breakfastType: [],
    region: [],
    language: [],
    swimmingPool: false,
    pickUp: false,
    priceMin: null,
    priceMax: null,
};

/**
 * Nombre de filtres actifs (somme des cases cochées + bascules booléennes +
 * fourchette de prix définie + « données incomplètes »). Sert au badge du
 * déclencheur mobile et à l'activation du bouton de réinitialisation.
 */
export function countActiveFilters(filters: ProductFiltersState, incompleteOnly: boolean): number {
    const checkboxCount = Object.values(filters).reduce<number>(
        (acc, value) => acc + (Array.isArray(value) ? value.length : 0),
        0,
    );
    const priceCount = filters.priceMin !== null || filters.priceMax !== null ? 1 : 0;
    const booleanCount = (filters.swimmingPool ? 1 : 0) + (filters.pickUp ? 1 : 0);
    return checkboxCount + priceCount + booleanCount + (incompleteOnly ? 1 : 0);
}
